module.exports = __webpack_public_path__ + "static/media/01D.5d75c314.png";